import { render, staticRenderFns } from "./InquiryType.vue?vue&type=template&id=dbc7dfe8&"
import script from "./InquiryType.vue?vue&type=script&lang=js&"
export * from "./InquiryType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports